import DashboardPage from "views/Dashboard/Dashboard.jsx";
import UserProfile from "views/UserProfile/UserProfile.jsx";
import DappProfile from "views/DappProfile/DappProfile.jsx";
import TableList from "views/TableList/TableList.jsx";
import About from "views/About/About.jsx";
// import Typography from "views/Typography/Typography.jsx";
// import Icons from "views/Icons/Icons.jsx";
// import SweetAlert from "views/Components/SweetAlert.jsx";
// import AddDappAlert from "views/Components/AddDappAlert.jsx"

// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Games from "@material-ui/icons/Games";
import Casino from "@material-ui/icons/Casino";
import Collections from "@material-ui/icons/Collections";
import Store from "@material-ui/icons/Store";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Extension from "@material-ui/icons/Extension";
import ShowChart from "@material-ui/icons/ShowChart";
import BubbleChart from "@material-ui/icons/BubbleChart";


const dashboardRoutes = [
    {
        path: "/rankings",
        sidebarName: "Rankings ÐApps",
        navbarName: "Rankings ÐApps",
        icon: ShowChart,
        component: TableList
    },
    {
        exact: true,
        path: "/",
        sidebarName: "All ÐApps",
        navbarName: "All ÐApps",
        icon: Dashboard,
        component: DashboardPage
    },
    {
        path: "/games",
        sidebarName: "Games",
        navbarName: "Games",
        icon: Games,
        component: DashboardPage
    },
    {
        path: "/marketplaces",
        sidebarName: "Marketplaces",
        navbarName: "Marketplaces",
        icon: Store,
        component: DashboardPage
    },
    {
        path: "/casinos",
        sidebarName: "Casinos",
        navbarName: "Casinos",
        icon: Casino,
        component: DashboardPage
    },
    {
        path: "/collectibles",
        sidebarName: "Collectibles",
        navbarName: "Collectibles",
        icon: Collections,
        component: DashboardPage
    },
    {
        path: "/pyramids",
        sidebarName: "Pyramids",
        navbarName: "Pyramids",
        icon: MonetizationOn,
        component: DashboardPage
    },
    {
        path: "/tools",
        sidebarName: "Tools",
        navbarName: "Tools",
        icon: Extension,
        component: DashboardPage
    },
    {
        path: "/others",
        sidebarName: "Others",
        navbarName: "Others",
        icon: BubbleChart,
        component: DashboardPage
    //  component: Typography
    },
    {
        path: "/dapp/",
        sidebarName: "",
        sidebarHide: true,
        navbarName: "Dapp",
        navbarHide: true,
        icon: BubbleChart,
        component: DappProfile,
    },
    {
        path: "/user/",
        sidebarName: "",
        sidebarHide: true,
        navbarName: "User",
        navbarHide: true,
        icon: BubbleChart,
        component: UserProfile,
    },
    {
        path: "/about",
        sidebarName: "",
        sidebarHide: true,
        navbarName: "About",
        navbarHide: true,
        icon: BubbleChart,
        component: About,
    },
    {
        redirect: true,
        path: "/home",
        to: "/",
        navbarName: "Redirect"
    }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx